var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var BackButtonArrow = function () { return (_jsx("svg", __assign({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11.3438 5.34375V6.65625H3.34375L7 10.3438L6.0625 11.2812L0.78125 6L6.0625 0.71875L7 1.65625L3.34375 5.34375H11.3438Z", fill: "#1A212E" }) }))); };
export default BackButtonArrow;
